import React, { useEffect, useState } from "react";
import WoodSupplierTaskService from "services/WoodSupplierTaskService";

// Utility to convert string to base64
const toBase64 = (str) => {
  return btoa(unescape(encodeURIComponent(str)));
};

const ViewImage = ({ fileUrl }) => {
  const [imgSrc, setImgSrc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchImage = async () => {
      try {
        const base64FileUrl = toBase64(fileUrl);
        const res = await WoodSupplierTaskService.getImageUrl(base64FileUrl);
        console.log("Image API response:", res);

        const base64 = res?.data?.response?.fileContent;
        if (base64) {
          setImgSrc(`data:image/jpeg;base64,${base64}`);
        } else {
          setError("No image content found");
        }
      } catch (err) {
        console.error("Error loading image:", err);
        setError("Failed to load image");
      } finally {
        setLoading(false);
      }
    };

    if (fileUrl) {
      fetchImage();
    }
  }, [fileUrl]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div style={{ color: "red" }}>{error}</div>;

  return (
    <img
      src={imgSrc}
      alt="image"
      style={{
        maxWidth: 40,
        maxHeight: 40,
        marginRight: 8,
        borderRadius: "5px",
      }}
    />
  );
};

export default ViewImage;
